"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WWAssigneePerformanceClient = void 0;
const dp_http_client_lib_1 = require("@greatmindsorg/dp-http-client-lib");
const sdk_constants_1 = require("../../../../../constants/sdk.constants");
const serializers_1 = require("../../../../serializers");
class WWAssigneePerformanceClient {
    static newInstance(options, retryOptions) {
        return new WWAssigneePerformanceClient(dp_http_client_lib_1.RetryableHttpClient.newInstance(options, retryOptions), new serializers_1.AssigneePerformanceByCriteriaSerializer());
    }
    constructor(client, assigneePerformanceByCriteriaSerializer) {
        this.client = client;
        this.assigneePerformanceByCriteriaSerializer = assigneePerformanceByCriteriaSerializer;
    }
    async findVocabByContextAndAssessment(contextId, assessmentId, headers) {
        const response = await this.client.get(`${sdk_constants_1.ANALYTICS_API_PREFIX}/performance/ww/vocab/assigneePerformance.findByContextAndAssessment`, {
            headers,
            params: {
                contextId,
                assessmentId,
            },
        });
        const { data } = response.body;
        return data.map((item) => this.assigneePerformanceByCriteriaSerializer.serializeOne(item));
    }
}
exports.WWAssigneePerformanceClient = WWAssigneePerformanceClient;
//# sourceMappingURL=ww-assignee-performance.client.js.map